
const EmotionalFooter = () => {
  return (
    <footer className="bg-muted/10">
      {/* Quote Section */}
      <div className="section-padding text-center border-t border-muted">
        <div className="max-w-4xl mx-auto">
          <blockquote className="text-2xl md:text-4xl font-serif italic text-muted-foreground mb-4">
            "Nous n'héritons pas de la terre de nos parents, nous l'empruntons à nos enfants."
          </blockquote>
          <p className="text-sm text-muted-foreground">— Proverbe amérindien</p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="py-12 px-4 border-t border-muted">
        <div className="container mx-auto text-center text-sm text-muted-foreground">
          <p>© 2025 Legatia. Tous droits réservés. Fait avec ❤️ pour les familles.</p>
        </div>
      </div>
    </footer>
  );
};

export default EmotionalFooter;
